import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  generalConfigFromGlobal,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
  buildHeaderDataShell,
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-efile-elements-list-tpl',
    templateUrl: './efile-elements-list-tpl.component.html',
    styleUrls: ['./efile-elements-list-tpl.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EfileElementsListTplComponent implements OnInit, OnDestroy {
  private readonly subs = new Subscription();

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private isInitialized = false;
  baseURLs: any = {};
  headerData: any = {};
  rowData: any = {};
  filterParams: any = {};
  rowDataKeys: string[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => this.applyWorkspaceContext())
    );
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => this.applyWorkspaceContext())
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.headerData = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.filterParams = normalizeFilterParams(activeScreen);
    if (!this.isInitialized) {
      this.isInitialized = true;
      this.rowDataKeys =
        this.rowData && typeof this.rowData === 'object' && !Array.isArray(this.rowData)
          ? Object.keys(this.rowData)
          : [];
    }
    this.cdr.markForCheck();
  }

  refresh(): void {
    this.requestGridUpdate.emit('refresh');
  }
}
